// bao migrate skip
import "./../../bindings/bao-tabs";
import "./../../bindings/bao-number-box";
// bao migrate - module not found: import "bindings/toggle-buttons";
import "./../../bindings/bao-searcher";
import "./../../factories/translate-dialog";
import BaseSearchPaging2 from "./../../factories/search-paging2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabPage from "./../../factories/tab-page";
import BaoDialog from "./../../factories/bao-dialog";
//import TabController = window.baorequire("Factories/TabController");
import TranslateDialogViewModel from "./../../factories/translate-dialog";
class TagViewModel extends BaseSearchPaging2 {
    //TabViewModel = new TabController(false);
    FormName = ko.observable();
    TagOrgUnit = ko.observableArray().extend({ dirty: this.TabPage.DirtyFlag });
    TagAreaTab;
    TagOrgUnitTab;
    TagTypeId: KnockoutObservable<string>;
    Decimals: KnockoutObservable<number>;
    Description: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Description1();
                case 2:
                    return this.Description2();
                case 3:
                    return this.Description3();
                case 4:
                    return this.Description4();
                case 5:
                    return this.Description5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Description1(value);
                    break;
                case 2:
                    this.Description2(value);
                    break;
                case 3:
                    this.Description3(value);
                    break;
                case 4:
                    this.Description4(value);
                    break;
                case 5:
                    this.Description5(value);
                    break;
            }
        }
    });
    Description1: KnockoutObservable<string> = ko.observable("");
    Description2: KnockoutObservable<string> = ko.observable("");
    Description3: KnockoutObservable<string> = ko.observable("");
    Description4: KnockoutObservable<string> = ko.observable("");
    Description5: KnockoutObservable<string> = ko.observable("");
    //CsvOptions: KnockoutObservable<string>;
    YesNoPositiveText: KnockoutObservable<string>;
    YesNoNegativeText: KnockoutObservable<string>;
    CsvOptionsForUI = ko.observable("");
    CsvOptionsBold = ko.observable(false);
    CsvOptionsUnderlined = ko.observable(false);
    CsvOptions = ko.observable("");
    DateTimePickerValue: KnockoutObservable<string> = ko.observable("");
    SearchObjectId = ko.observable("");
    /**
     * Liefert true wenn der gewählte TagType numerisch ist.
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsNumeric = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" && this.TagTypeId() === '1eb0ef5b-07bd-476c-8415-d32931cd6bca');
    });
    /**
     * Liefert true wenn der gewählte TagType YesNo ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsYesNo = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" && this.TagTypeId() === '6c4865b4-3e87-4f64-be09-9e461e88550a');
    });
    /**
     * Liefert true wenn der gewählte TagType Caption ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsCaption = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" && this.TagTypeId() === '81c0785b-98b9-45ea-b260-6c6076d5ba3f');
    });
    /**
     * Liefert true wenn der gewählte TagType nicht Caption ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsNotCaption = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" && this.TagTypeId() !== '81c0785b-98b9-45ea-b260-6c6076d5ba3f');
    });
    /**
     * Liefert true wenn der gewählte TagType RadioButtons ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsRadioButtons = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" && (this.TagTypeId() === 'b3f7d21b-56dc-4258-91ba-00f0d64cb2b2'
            ||
                this.TagTypeId() === '02dd5bf9-f182-4368-917e-dd053ee2f4a7'));
    });
    TagTypeNeedsCsvOptions = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" && (this.TagTypeId() === 'b3f7d21b-56dc-4258-91ba-00f0d64cb2b2'
            ||
                this.TagTypeId() === '02dd5bf9-f182-4368-917e-dd053ee2f4a7'
            ||
                this.TagTypeId() === '0fc89eed-9510-4094-a0a8-835cee0a3f24' //=BaoSearcher
        ));
    });
    /**
    * Liefert true wenn der gewählte TagType nicht Platzhalter oder Platzhalter (Linie) ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsNotCaptionNorPlaceholder = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" &&
            this.TagTypeId() !== '6f5ad806-d399-4bb5-8417-567041b9ecc6'
            && this.TagTypeId() !== '80282140-301b-4c8a-8144-e4be45f2de43'
            && this.TagTypeId() !== '81c0785b-98b9-45ea-b260-6c6076d5ba3f');
    });
    /**
    * Liefert true wenn der gewählte TagType Datum/Zeitauswahl ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsDateTimePicker = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" && this.TagTypeId() === 'e2a64241-6766-4159-81d7-257da36327bb');
    });
    /**
    * Liefert true wenn der gewählte TagType TextArea ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsTextArea = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" && this.TagTypeId() === 'b453e0de-0f88-4f22-bfff-a0189f6a117b');
    });
    /**
    * Liefert true wenn der gewählte TagType Suchdialog mit Suchobjekt (BaoSearcherWithObject) ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsBaoSearcherWithObject = ko.pureComputed(() => {
        return Boolean(typeof this.TagTypeId === "function" && this.TagTypeId() === '8de0ffb8-1250-4322-85ee-2a64c46bbb78');
    });
    DecimalsCalc = ko.pureComputed(() => {
        var decimals = ko.unwrap(this.Decimals);
        return decimals == null ? 0 : decimals;
    });
    PermissionForward = "ForwardTag";
    PermissionBackward = "BackwardTag";
    InitUrl() {
        return "MasterData/Tag/Init";
    }
    init() {
        return super.init()
            .then(() => { return this.InitTabController(); })
            .then(() => {
            this.TagOrgUnitTab = new TabPage(null);
            this.TagOrgUnitTab.IsClosable(false);
            this.TagOrgUnitTab.Url("MasterData/TagOrgUnit");
            this.TagOrgUnitTab.AutoSelect = true;
            this.TagAreaTab = new TabPage(null);
            this.TagAreaTab.IsClosable(false);
            this.TagAreaTab.Url("MasterData/TagArea");
            this.TagAreaTab.AutoSelect = false;
            this.TabController.AddTab(this.TagOrgUnitTab);
            this.TabController.AddTab(this.TagAreaTab);
        });
    }
    StringIsNullOrEmpty(pstr) {
        return (typeof pstr === "undefined" || pstr === null || pstr === "");
    }
    CompleteCheck() {
        var isComplete = true;
        if ( //Bao.Utils.String.IsNullOrEmpty(self.TagName()) ||
        Bao.Utils.String.IsNullOrEmpty(this.Description()) ||
            //Bao.Utils.String.IsNullOrEmpty(self.Unit()) ||
            Bao.Utils.String.IsNullOrEmpty(this.TagTypeId())) {
            isComplete = false;
        }
        if (this.TagTypeIsRadioButtons() &&
            this.StringIsNullOrEmpty(ko.unwrap(this.CsvOptions))) {
            isComplete = false;
        }
        if (this.TagTypeIsYesNo() &&
            (this.StringIsNullOrEmpty(ko.unwrap(this.YesNoPositiveText)) ||
                this.StringIsNullOrEmpty(ko.unwrap(this.YesNoNegativeText)))) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        // Nicht mehr als 100 Zeilen für die TextArea  
        if (this.TagTypeIsTextArea) {
            let value = parseInt(ko.unwrap(this.CsvOptions));
            if (value != null && (value < 1 || value > 100)) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgLessRows"), "info");
            }
        }
        return isComplete;
    }
    ;
    MinimizeEntity() {
        let minimizedEntity = super.MinimizeEntity();
        if (this.TagTypeIsCaption()) {
            let options = [];
            if (this.CsvOptionsBold()) {
                options.push("Bold");
            }
            if (this.CsvOptionsUnderlined()) {
                options.push("Underlined");
            }
            minimizedEntity.CsvOptions = options.join(",");
        }
        if (this.TagTypeIsDateTimePicker()) {
            minimizedEntity.CsvOptions = this.DateTimePickerValue();
        }
        return minimizedEntity;
    }
    Translate() {
        var translateDialog = new TranslateDialogViewModel(this.Description1, this.Description2, this.Description3, this.Description4, this.Description5);
        translateDialog.Open().then(() => {
        });
    }
    ;
}
export default TagViewModel;